module.exports = __webpack_public_path__ + "img/swords.adf98473.svg";